export const ON_SUCCESS_LOGIN = 'ON_SUCCESS_LOGIN';
export const ON_SUCCESS_SIGNUP = 'ON_SUCCESS_SIGNUP';
export const ON_OPEN_ENTRY_MODAL = 'ON_OPEN_ENTRY_MODAL';
export const ON_SCROLL_LOCK_LOCK = 'ON_SCROLL_LOCK_LOCK';
export const ON_SCROLL_LOCK_UNLOCK = 'ON_SCROLL_LOCK_UNLOCK';
export const ON_LOGOUT = 'ON_LOGOUT';
export const NOT_TOKENS_FOR_REQUEST = 'NOT_TOKENS_FOR_REQUEST';
export const ON_AUTH_REQUEST_ERROR_400 = 'ON_AUTH_REQUEST_ERROR_400';
export const ON_CABINET = 'ON_CABINET';
export const ON_RECEIVED_TOKENS = 'ON_RECEIVED_TOKENS';
export const ON_OPEN_GALLERY = 'ON_OPEN_GALLERY';
export const ON_OPEN_IMAGE_EDITOR = 'ON_OPEN_IMAGE_EDITOR';
export const ON_OPEN_STORE_CART = 'ON_OPEN_STORE_CART';
export const ON_OPEN_STORE = 'ON_OPEN_STORE';
export const ON_ROUTE = 'ON_ROUTE';
export const ON_CHANGE_LANG = 'ON_CHANGE_LANG';
export const ON_OPEN_ESTIMATE = 'ON_OPEN_ESTIMATE';
